import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wizard-panels" }
const _hoisted_2 = { class: "wizard-panels__left d-flex flex-column" }
const _hoisted_3 = { class: "d-flex align-items-center fs-18 mb-4" }
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = { class: "wizard-panels__right p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_SceneStepItemsList = _resolveComponent("SceneStepItemsList")
  const _component_DialogAddAction = _resolveComponent("DialogAddAction")
  const _component_DialogSceneStepItemsListReorder = _resolveComponent("DialogSceneStepItemsListReorder")
  const _component_ScenePanelObjects = _resolveComponent("ScenePanelObjects")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_ScenePanelTime = _resolveComponent("ScenePanelTime")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("strong", _hoisted_4, _toDisplayString(_ctx.scene.actions.length), 1),
        _createVNode("span", null, _toDisplayString(_ctx.actionText), 1),
        (_ctx.scene.actions.length > 1)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-text ml-1 fs-18",
              onClick: _ctx.openReorderDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResource.ReorderActions")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_SceneStepItemsList, {
        items: _ctx.scene.actions,
        onEdit: _ctx.handleEdit,
        onRemove: _ctx.handleRemove,
        class: "flex-shrink-1"
      }, null, 8, ["items", "onEdit", "onRemove"]),
      _createVNode(_component_DialogAddAction, {
        "is-visible": _ctx.isVisibleDialogEditAction,
        "onUpdate:is-visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisibleDialogEditAction = $event)),
        onConfirm: _ctx.handleDoEditAction,
        actionToAdd: _ctx.tempActionToEdit
      }, null, 8, ["is-visible", "onConfirm", "actionToAdd"]),
      _createVNode(_component_DialogSceneStepItemsListReorder, {
        items: _ctx.scene.actions,
        "is-visible": _ctx.isVisibleDialogReorderAction,
        "onUpdate:is-visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isVisibleDialogReorderAction = $event)),
        onConfirm: _ctx.handleDoReorderAction
      }, null, 8, ["items", "is-visible", "onConfirm"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_TabView, { class: "p-tabview--custom" }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.ObjectCapitalized')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ScenePanelObjects, {
                roomsWithObjects: _ctx.roomObjectsActions,
                "step-to-add": _ctx.SceneWizardStepEnum.STEP_ACTION,
                onAddAction: _cache[3] || (_cache[3] = (action) => _ctx.handleAddAction(action))
              }, null, 8, ["roomsWithObjects", "step-to-add"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.WaitingTime')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ScenePanelTime, {
                name: _ctx.$t('AppResource.WaitingTime'),
                "step-to-add": _ctx.SceneWizardStepEnum.STEP_ACTION,
                onAddAction: _cache[4] || (_cache[4] = (action) => _ctx.handleAddAction(action))
              }, null, 8, ["name", "step-to-add"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      })
    ])
  ]))
}